import type { AnyAction } from 'redux';

import { PartsAndLaborGuideActionTypes } from 'redux/actions/parts-and-labor-guide/actionTypes';

export type PartsAndLaborInitialState = {
  motorDotComBreadcrumbs: any[];
  motorDotComGuide: any[];
  motorDotComLoading: false;
  motorDotComPartsGuide: any | Record<string, never>;
  motorDotComVinSearchResults: any[];
  motorDotComYears: any[];
};

const initialState: PartsAndLaborInitialState = {
  motorDotComBreadcrumbs: [],
  motorDotComGuide: [],
  motorDotComLoading: false,
  motorDotComPartsGuide: {},
  motorDotComVinSearchResults: [],
  motorDotComYears: [],
};

const partsAndLaborGuideReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case PartsAndLaborGuideActionTypes.SET_PL_GUIDE_STATE:
      return { ...state, [action.key]: action.value };
    case PartsAndLaborGuideActionTypes.RESET_PL_STATE:
      return { ...initialState };
    default:
      return state;
  }
};

export default partsAndLaborGuideReducer;
